module.exports = __webpack_public_path__ + "static/media/logo.d87a6a01.png";